export default {
  rankOrder: {
    ariaAddOption: 'Adicionar {label} à lista classificada',
    ariaMoveUp: 'Mover {label} para cima',
    ariaMoveDown: 'Mover {label} para baixo',
    ariaRemoveOption: 'Remover {label} da lista classificada',
  },
  coe: {
    ariaDisclaimer: 'Aviso',
    ariaQuestion: 'Pergunta',
    ariaConversationHistory: 'Histórico da conversa',
    ariaYourResponse: 'A sua resposta {number}',
    ariaFollowUpQuestion: 'Pergunta de acompanhamento {number}',
    ariaResponseInput: 'Campo de resposta',
    ariaRespondingTo: 'Responder a',
    ariaSendResponse: 'Enviar resposta',
    ariaThinking: 'A pensar'
  },
  deviceView: {
    toolbar: 'Dispositivo de pré-visualização',
    mobile: 'Telemóvel',
    tablet: 'Tablet',
    desktop: 'Computador'
  },
  header: {
    customLogoAlt: 'Logótipo',
    defaultLogoAlt: 'Logótipo QuestDIY'
  }
}
